import { Card } from "@/components/ui/card";
import { LANDING } from "@/constants/testIds";
import { BookOpen, Home, MapPin, Users } from "lucide-react";

function Metric({ label, value, icon: Icon, testId, accent }) {
  return (
    <Card className="bg-white rounded-2xl border border-stone-200 shadow-[0_4px_24px_rgba(0,0,0,0.04)] p-6 sm:p-7 hover:-translate-y-0.5 transition-transform duration-300">
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="text-xs uppercase tracking-[0.18em] text-stone-500 font-semibold">{label}</div>
          <div
            data-testid={testId}
            className="font-serif text-4xl sm:text-5xl font-semibold text-[#122036] mt-2 tabular-nums"
          >
            {value.toLocaleString()}
          </div>
        </div>
        <div
          className="w-10 h-10 rounded-full grid place-items-center shrink-0"
          style={{ background: accent + "1A", color: accent }}
          aria-hidden
        >
          <Icon size={20} strokeWidth={2.2} />
        </div>
      </div>
    </Card>
  );
}

export default function ImpactCounters({ stats }) {
  const s = stats || {};
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
      <Metric
        label="Libraries installed"
        value={s.total_installed || 0}
        icon={Home}
        accent="#22C55E"
        testId={LANDING.counterInstalled}
      />
      <Metric
        label="Families served"
        value={s.total_registered || 0}
        icon={Users}
        accent="#F4A6A6"
        testId={LANDING.counterFamilies}
      />
      <Metric
        label="Neighborhoods reached"
        value={s.neighborhoods_reached || 0}
        icon={MapPin}
        accent="#3DA9DC"
        testId={LANDING.counterNeighborhoods}
      />
      <Metric
        label="Children with home libraries"
        value={s.children_served || 0}
        icon={BookOpen}
        accent="#F4B91C"
        testId={LANDING.counterChildren}
      />
    </div>
  );
}
